<template>
    <div>
        <app-tabela
            idTabela="tblRateios"
            :itens="rateios"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
        >   
            <template slot="nomeProjeto" slot-scope="data">
                ({{ data.codProjeto }}) {{ data.nomeProjeto }} 
            </template>
            <template slot="nomeAcao" slot-scope="data">
                ({{ data.codAcao }}) {{ data.nomeAcao }} 
            </template>
            <template slot="nomeUnidade" slot-scope="data">
                ({{ data.codUnidade }}) {{ data.nomeUnidade }} 
            </template>
            <template slot="valor" slot-scope="data">
                {{ data.valor | currency }}
            </template>
            <template slot="rateiosAcoes" slot-scope="data">
                <slot name="rateiosAcoes" v-bind="data"></slot>
            </template>
        </app-tabela>
    </div>
</template>

<script>

export default {
    props: {
        rateios: {
            type: Array,
        },
    },

    data() {
        return {
            campos: [
                {
                    key: 'nomeProjeto',
                    label: 'Projeto',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nomeAcao',
                    label: 'Ação',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nomeUnidade',
                    label: 'Unidade',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
            ],
            itensPorPagina: 0
        }
    }
}

</script>